/* AEF — PDP title↔variant suffix sync (fix go-live bug 2026-06).
   Bug: H1 shows "Name — Pack Of 30" but stays stale when a different pack is
   selected (price updates, suffix doesn't). This is a safe, self-contained
   writer for .aef-title-variant. Derives the label straight from the SELECTED
   option value, so it always matches the picker. Runs on load + every change.
   No dependency on the section's variant-meta JSON. */
(function () {
  function selectedLabel() {
    // Button picker (radios)
    var r = document.querySelector(
      'variant-radios input[type="radio"]:checked,' +
      '.product-form__input input[type="radio"]:checked,' +
      'fieldset.product-form__input input[type="radio"]:checked'
    );
    if (r && r.value) return r.value.trim();
    // Dropdown picker
    var s = document.querySelector('variant-selects select, .product-form__input select');
    if (s && s.value) return s.value.trim();
    return null;
  }
  function sync() {
    var span = document.querySelector('.product__title .aef-title-variant');
    if (!span) return; // only on multi-variant PDP that renders the suffix
    var label = selectedLabel();
    if (label) span.textContent = ' — ' + label; // nbsp + em-dash (matches Liquid render)
  }
  function boot() { setTimeout(sync, 60); } // let the theme's own variant JS settle first
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Any variant change: native change bubbling from the picker…
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('variant-radios, variant-selects, .product-form__input')) {
      setTimeout(sync, 0);
    }
  }, true);
  // …and Dawn-style custom variant events, just in case.
  document.addEventListener('variant:change', function () { setTimeout(sync, 0); });
  document.addEventListener('on:variant:change', function () { setTimeout(sync, 0); });
})();
